module.exports = __webpack_public_path__ + "static/media/19.696113ae.jpg";